module.exports = {"Operate9":{"daobanList":[{"title":"1:法律、行政法规规定的其他材料","values":[{"name":"关于“法律、行政法规规定的其它材料”，仅指《互联网上网服务营业场所管理条例》等法律法规规定的前置材料，即互联网上网服务营业场所申办公众聚集场所投入使用、营业前消防安全检查时，应当提交由文化广电部门出具的《互联网上网服务营业场所筹建意见书》复印件","xuanzhong":1,"cailiaoList":[{"name":"1、营业执照","state":"必要"},{"name":"2、消防安全制度、灭火和应急疏散预案","state":"支持容缺处理"},{"name":"3、场所品管布置图、场所消防设施平面图","state":"支持容缺处理"}]},{"name":"申请书、授权委托书等","xuanzhong":0,"cailiaoList":[{"name":"1、公众聚集场所投入使用、营业消防安全告知承诺书","state":"必要"},{"name":"2、营业执照","state":"必要"},{"name":"3、消防安全制度、灭火和应急疏散预案","state":"支持容缺处理"},{"name":"4、场所品管布置图、场所消防设施平面图","state":"支持容缺处理"}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdo-9.json
// module id = 1289
// module chunks = 0